import { render, staticRenderFns } from "./ImtListModal.vue?vue&type=template&id=8236669a&scoped=true"
import script from "./ImtListModal.vue?vue&type=script&lang=js"
export * from "./ImtListModal.vue?vue&type=script&lang=js"
import style0 from "./ImtListModal.vue?vue&type=style&index=0&id=8236669a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8236669a",
  null
  
)

export default component.exports